import React from 'react'
import styles from './styles.module.css'

export const Check = ({ name, event }) => (
  <div className={styles.Container}>
    <input type="checkbox" onChange={(e) => event(e.target.checked)} />
    <div>Si {name} no es el dueño de la cuenta selecciona esta opción</div>
  </div>
)
